<template>
  <component :is="game_history_component" />
</template>

<script>
import GameHistoryDesktopContent from "@/components/Content/ContentGameHistoryDesktop";
import GameHistoryMobileContent from "@/components/Content/ContentGameHistoryMobile";

export default {
  name: "SectionGameHistory",
  components: {
    GameHistoryDesktopContent,
    GameHistoryMobileContent
  },
  data: () => ({
    game_history_component: null
  }),
  methods: {
    load_component_content() {
      this.game_history_component = window.matchMedia("(min-width:1025px)")
        .matches
        ? "game-history-desktop-content"
        : "game-history-mobile-content";
    }
  },
  created() {
    this.load_component_content();
    window.addEventListener("resize", () => {
      this.load_component_content();
    });
  }
};
</script>
